// extracted by mini-css-extract-plugin
module.exports = {"presalePopupText":"style_presalePopupText__6AKXq","closeSvg":"style_closeSvg__mjWdL","presaleTitle":"style_presaleTitle__BEHc_"};